import type { App } from "vue";

import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import locale_cs from "dayjs/locale/cs";
import locale_en from "dayjs/locale/en";

import { useSettingsStore } from "@/stores/settings";
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

export default {
  install: (app: App) => {
    app.config.globalProperties.$ldayjs = function () {
      const settingsStore = useSettingsStore();

      if (settingsStore.language == "cs") {
        dayjs.locale(locale_cs);
      } else {
        dayjs.locale(locale_en);
      }

      return dayjs;
    };
  },
};

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $ldayjs: () => typeof dayjs;
  }
}
